import { handleBillAddressToggle, handleFinishButtonClick, handlePasswordToggle, startTimer } from './functions.js'
import { BUTTON_CLASSES, ELEMENT_SELECTORS } from './constants.js'

const finishButton = document.querySelector<HTMLButtonElement>(BUTTON_CLASSES.finish)
const billAddressButton = document.querySelector<HTMLInputElement>(BUTTON_CLASSES.billAddressToggle)
const billAddressDiv = document.querySelector<HTMLDivElement>(ELEMENT_SELECTORS.billAddress)
const loginEyeSVG = document.querySelector<SVGElement>(BUTTON_CLASSES.passwordToggle)
const timerSpan = document.querySelector<HTMLSpanElement>(ELEMENT_SELECTORS.timer)
const registrationForm = document.querySelector<HTMLFormElement>(ELEMENT_SELECTORS.registrationForm)

if (finishButton && registrationForm) {
  handleFinishButtonClick(finishButton, registrationForm)
}
if (billAddressButton && billAddressDiv) {
  handleBillAddressToggle(billAddressButton, billAddressDiv)
}
if (loginEyeSVG) {
  handlePasswordToggle(loginEyeSVG)
}
if (timerSpan) {
  startTimer(timerSpan)
}